import React, { Component } from 'react'
import * as XLSX from 'xlsx'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

const PAGE_SIZE = 30

const MESES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
const EJERCICIOS = Array.from({ length: 16 }, (_, i) => new Date().getFullYear() - 10 + i).map(String)

const DOM_STORAGE_KEY = 'dom_filters_v1'
function saveDomFilters(state) {
    try {
        sessionStorage.setItem(DOM_STORAGE_KEY, JSON.stringify({
            estado: state.estado || '',
            municipio: state.municipio || '',
            colonia: state.colonia || '',
            calle: state.calle || '',
            status: state.status || '',
            control: state.control || '',
            tipo: state.tipo || '',
            mostrarInactivas: state.mostrarInactivas || false,
            mostrarSociedadesFinalizadas: state.mostrarSociedadesFinalizadas || false,
            currentPage: state.currentPage || 1,
            sortKey: state.sortKey || 'calle',
            sortAsc: state.sortAsc !== false,
        }))
    } catch(e) {}
}
function loadDomFilters() {
    try {
        const raw = sessionStorage.getItem(DOM_STORAGE_KEY)
        if (raw) return JSON.parse(raw)
    } catch(e) {}
    return null
}
function clearDomFilters() {
    try { sessionStorage.removeItem(DOM_STORAGE_KEY) } catch(e) {}
}

function formatMoney(amount) {
    if (!amount && amount !== 0) return '—'
    if (isNaN(amount)) return '—'
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount)
}

class DomicilioComponent extends Component {
    constructor(props) {
        super(props)
        const saved = loadDomFilters()

        this.state = {
            ...props,
            allClientes: [],
            allSociedades: [],
            cliente: '',
            sociedadSeleccionada: '',
            ejercicio: new Date().getFullYear(),
            periodo: MESES[new Date().getMonth()],
            estado:    saved?.estado    || '',
            municipio: saved?.municipio || '',
            colonia:   saved?.colonia   || '',
            calle:     saved?.calle     || '',
            status:    saved?.status    || '',
            control:   saved?.control   || '',
            tipo:      saved?.tipo      || '',
            busqueda: '',
            mostrarInactivas:            saved?.mostrarInactivas            || false,
            mostrarSociedadesFinalizadas: saved?.mostrarSociedadesFinalizadas || false,
            modoReporte: false,
            uncollapseRows: false,
            currentPage: saved?.currentPage || 1,
            sortKey: saved?.sortKey || 'calle',
            sortAsc: saved?.sortAsc !== false,
            errorMsg: '',
        }
        this.goBusqueda = this.goBusqueda.bind(this)
        this.loadDomiciliosList = this.loadDomiciliosList.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_DOMICILIOS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        this.loadDomiciliosList()
    }

    loadDomiciliosList() {
        ElementsDataService.retrieveAllElements('domicilios')
            .then(r => {
                this.setState({ elements: this.doSort('calle', true, r.data) })
                return ElementsDataService.retrieveAllElements("clientes")
            })
            .then(r => this.setState({ allClientes: r.data, loading: false }))
        ElementsDataService.retrieveAllElements("sociedades-selector")
            .then(r => this.setState({ allSociedades: r.data }))
    }

    getGastosByPeriodoEjercicio(ejercicio = this.state.ejercicio, periodo = this.state.periodo) {
        this.setState({ loading: true })
        ElementsDataService.retrieveAllElements(`domicilios/${ejercicio}/${periodo}/${this.state.busqueda.toUpperCase() || 'all-todos'}`)
            .then(r => this.setState({ elements: this.doSort('calle', true, r.data), periodo, ejercicio, loading: false }))
    }

    setFilterState(updates, cb) {
        this.setState(updates, () => {
            saveDomFilters(this.state)
            if (cb) cb()
        })
    }

    goBusqueda() {
        this.setState({ loading: true, uncollapseRows: true })
        const q = this.state.busqueda.toUpperCase()
        if (q.length > 2) {
            ElementsDataService.retrieveAllElements(`domicilios/${this.state.ejercicio}/${this.state.periodo}/${q}`)
                .then(r => {
                    this.setState({
                        elements: this.doSort('calle', true, r.data),
                        loading: false,
                        errorMsg: r.data.length === 0 ? 'Esta búsqueda no arroja resultados.' : ''
                    })
                })
        } else if (this.state.modoReporte) {
            ElementsDataService.retrieveAllElements(`domicilios/${this.state.ejercicio}/${this.state.periodo}/all-todos`)
                .then(r => this.setState({ elements: this.doSort('calle', true, r.data), loading: false }))
        } else {
            this.setState({ elements: [], loading: false, errorMsg: 'Debe escribir al menos tres caracteres.' })
        }
    }

    doSort(key, asc, arr) {
        return [...arr].sort((a, b) => {
            const va = (a[key] !== undefined && a[key] !== null ? a[key].toString().trim() : '')
            const vb = (b[key] !== undefined && b[key] !== null ? b[key].toString().trim() : '')
            if (va < vb) return asc ? -1 : 1
            if (va > vb) return asc ? 1 : -1
            return 0
        })
    }

    sortBy(key) {
        const asc = this.state.sortKey === key ? !this.state.sortAsc : true
        this.setState({ elements: this.doSort(key, asc, this.state.elements || []), sortKey: key, sortAsc: asc, currentPage: 1 })
    }

    descargarExcel(filtered, allClientes) {
        const data = filtered.map((el, i) => {
            const soc = el.sociedades?.[0]
            const clientes = soc?.clientesIds
                ?.map(cid => allClientes.find(x => x.id === cid)?.nombreCliente)
                .filter(Boolean).join(', ') || ''
            return {
                'N°':             i + 1,
                'Calle':          el.calle || '',
                'No Ext/Int':     (el.numeroExt || '') + (el.numeroInterior ? ' int. '+el.numeroInterior : ''),
                'Colonia':        el.colonia || '',
                'Municipio':      el.municipio || '',
                'Estado':         el.estado || '',
                'Teléfono':       el.telefono || '',
                'Estatus':        el.estatus || '',
                'Tipo':           el.tipo || '',
                'Sociedad':       soc?.razonSocial || '',
                'Clientes':       clientes,
                'Costo Renta':    el.costoArrendamiento || '',
                'Costo Periodo':  el.costoPeriodo || '',
                'Costo Unitario': el.costoPeriodo ? el.costoPeriodo / 5 : '',
                'Costo Acumulado':el.costoAcumuladoAnual || '',
            }
        })
        const ws = XLSX.utils.json_to_sheet(data)
        ws['!cols'] = [
            {wch:4},{wch:28},{wch:12},{wch:22},{wch:18},{wch:14},
            {wch:14},{wch:12},{wch:12},{wch:32},{wch:28},
            {wch:14},{wch:14},{wch:14},{wch:16},
        ]
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Domicilios')
        XLSX.writeFile(wb, 'Domicilios_' + new Date().toISOString().slice(0,10) + '.xlsx')
    }

    render() {
        const { allClientes, allSociedades, ejercicio, periodo, loading, estado, municipio,
            colonia, calle, status, control, tipo, mostrarInactivas, mostrarSociedadesFinalizadas,
            cliente, sociedadSeleccionada, modoReporte, uncollapseRows, busqueda,
            currentPage, sortKey, sortAsc, errorMsg } = this.state

        const elements = this.state.elements || []

        // Listas de filtros dinámicos
        const unique = (arr, key) => [...new Set(arr.map(e => e[key]?.toString().trim()).filter(Boolean))].sort()
        const estados = unique(elements, 'estado')
        // Cascade: municipios filtered by estado, colonias by estado+municipio, calles by all above
        const byEstado = estado ? elements.filter(e => e.estado?.trim() === estado) : elements
        const municipios = unique(byEstado, 'municipio')
        const byMunicipio = municipio ? byEstado.filter(e => e.municipio?.trim() === municipio) : byEstado
        const colonias = unique(byMunicipio, 'colonia')
        const byColonia = colonia ? byMunicipio.filter(e => e.colonia?.trim() === colonia) : byMunicipio
        const calles = unique(byColonia, 'calle')

        // Totales para modo reporte
        let totalRentas = 0, totalRentasRecibo = 0, totalPeriodo = 0, totalAnual = 0
        let totalSociedades = 0, totalDomiciliosControl = 0, sociedadesDomiciliosControl = 0
        // Excel export via descargarExcel()
        let counter = 0

        const filtered = elements.filter(el => {
            if (estado && el.estado?.toString().trim() !== estado) return false
            if (municipio && el.municipio?.toString().trim() !== municipio) return false
            if (colonia && el.colonia?.toString().trim() !== colonia) return false
            if (calle && el.calle?.toString().trim() !== calle) return false
            if (status) { if (status === 'SIN ESTATUS' ? el.estatus : el.estatus !== status) return false }
            if (control && el.control !== control) return false
            if (tipo && el.tipo !== tipo) return false
            if (!mostrarInactivas && el.estatus === 'INACTIVO') return false
            if (cliente || sociedadSeleccionada) {
                let flag = false
                el.sociedades?.forEach(s => {
                    if (cliente && s.clientesIds?.includes(cliente.id)) flag = true
                    if (sociedadSeleccionada && s.id === sociedadSeleccionada.id) flag = true
                })
                if (!flag) return false
            }
            return true
        })

        // Calcular totales y CSV
        filtered.forEach(el => {
            counter++
            const socsNoFin = el.sociedades?.filter(s => !s.fechaFin) || []
            const socsFinalizadas = el.sociedades?.filter(s => s.fechaFin) || []
            el._socsNoFin = socsNoFin; el._socsFinalizadas = socsFinalizadas
            if (el.costoArrendamiento) totalRentas += el.costoArrendamiento
            if (el.costoArrendamientoRecibo) totalRentasRecibo += el.costoArrendamientoRecibo
            if (el.costoPeriodo) totalPeriodo += el.costoPeriodo
            if (el.costoAcumuladoAnual) totalAnual += el.costoAcumuladoAnual
            totalSociedades += socsNoFin.length
            if (mostrarSociedadesFinalizadas) totalSociedades += socsFinalizadas.length
            if (el.control === 'CONTROL') { totalDomiciliosControl++; sociedadesDomiciliosControl += socsNoFin.length }

        })

        // Paginación
        const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))
        const page = Math.min(currentPage, totalPages)
        const pageData = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

        const SortIcon = ({ k }) => sortKey !== k
            ? <span style={{ color: '#cbd5e1', marginLeft: 4 }}>↕</span>
            : <span style={{ color: '#3b82f6', marginLeft: 4 }}>{sortAsc ? '↑' : '↓'}</span>

        const statusBadge = (s) => {
            if (!s) return <span style={{ color: '#cbd5e1' }}>—</span>
            const colors = {
                ACTIVO: { bg: '#dcfce7', color: '#16a34a', border: '#bbf7d0' },
                INACTIVO: { bg: '#fef9c3', color: '#ca8a04', border: '#fef08a' },
            }
            const c = colors[s] || { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' }
            return <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20, border: `1px solid ${c.border}`, background: c.bg, color: c.color, whiteSpace: 'nowrap' }}>{s}</span>
        }

        const tipoBadge = (t) => {
            if (!t) return <span style={{ color: '#cbd5e1' }}>—</span>
            const colors = {
                'FISICO': { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' },
                'VIRTUAL': { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe' },
                'DEL CLIENTE': { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' },
            }
            const c = colors[t] || { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' }
            return <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20, border: `1px solid ${c.border}`, background: c.bg, color: c.color, whiteSpace: 'nowrap', display: 'inline-block' }}>{t}</span>
        }

        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .dom-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .dom-select {
                        width: 100%; padding: 9px 14px; appearance: none;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.83rem; color: #334155; outline: none; cursor: pointer;
                        transition: all 0.2s; font-family: 'Inter', sans-serif;
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
                        background-repeat: no-repeat; background-position: right 10px center; padding-right: 28px;
                    }
                    .dom-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .dom-input {
                        width: 100%; padding: 9px 14px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.83rem; color: #334155; outline: none;
                        transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .dom-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .dom-th {
                        padding: 9px 12px; text-align: left; font-size: 0.68rem; font-weight: 700;
                        color: #64748b; letter-spacing: 0.7px; text-transform: uppercase;
                        border-bottom: 1px solid #e2e8f0; background: #f8fafc;
                        white-space: nowrap; user-select: none;
                    }
                    .dom-th.sortable { cursor: pointer; }
                    .dom-th.sortable:hover { color: #3b82f6; background: #f0f7ff; }
                    .dom-tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
                    .dom-tr:hover td { background: #f8faff !important; }
                    .dom-td { padding: 9px 12px; font-size: 0.8rem; color: #334155; vertical-align: top; }
                    .dom-link { color: #3b82f6; text-decoration: none; font-weight: 600; }
                    .dom-link:hover { text-decoration: underline; }
                    .btn-edit { padding: 4px 9px; border: 1px solid #e2e8f0; border-radius: 7px; background: white; cursor: pointer; font-size: 0.72rem; color: #64748b; transition: all 0.15s; }
                    .btn-edit:hover { border-color: #3b82f6; color: #3b82f6; background: #eff6ff; }
                    .btn-del { padding: 4px 9px; border: 1px solid #fee2e2; border-radius: 7px; background: white; cursor: pointer; font-size: 0.72rem; color: #ef4444; transition: all 0.15s; }
                    .btn-del:hover { background: #fef2f2; border-color: #ef4444; }
                    .btn-mode { padding: 8px 16px; border: 1px solid #e2e8f0; border-radius: 10px; background: white; cursor: pointer; font-size: 0.82rem; color: #475569; font-weight: 600; transition: all 0.2s; font-family: 'Inter', sans-serif; }
                    .btn-mode:hover { border-color: #3b82f6; color: #3b82f6; }
                    .btn-mode.active { background: #eff6ff; border-color: #3b82f6; color: #2563eb; }
                    .page-btn { min-width: 32px; height: 32px; padding: 0 8px; border: 1px solid #e2e8f0; border-radius: 7px; background: white; cursor: pointer; font-size: 0.8rem; color: #475569; transition: all 0.15s; font-family: 'Inter', sans-serif; display: flex; align-items: center; justify-content: center; }
                    .page-btn:hover:not(:disabled) { border-color: #3b82f6; color: #3b82f6; }
                    .page-btn.active { background: #3b82f6; color: white; border-color: #3b82f6; font-weight: 700; }
                    .page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
                    .toggle-wrap { display: flex; align-items: center; gap: 8px; cursor: pointer; }
                    .toggle { width: 36px; height: 20px; border-radius: 10px; border: none; cursor: pointer; transition: background 0.2s; position: relative; }
                    .toggle::after { content: ''; position: absolute; top: 3px; left: 3px; width: 14px; height: 14px; border-radius: 50%; background: white; transition: left 0.2s; }
                    .toggle.on { background: #3b82f6; }
                    .toggle.on::after { left: 19px; }
                    .toggle.off { background: #cbd5e1; }
                    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                    .dom-table-wrap { animation: fadeIn 0.3s ease; }
                    @keyframes spin { to { transform: rotate(360deg); } }
                    .spinner { width: 32px; height: 32px; border: 3px solid #e2e8f0; border-top-color: #3b82f6; border-radius: 50%; animation: spin 0.7s linear infinite; }
                `}</style>

                <div className="dom-root" style={styles.inner}>

                    {/* Header */}
                    <div style={styles.pageHeader}>
                        <div>
                            <h1 style={styles.pageTitle}>Domicilios</h1>
                            <p style={styles.pageSubtitle}>{filtered.length} domicilio{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}</p>
                        </div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                            <button className={`btn-mode${!modoReporte ? ' active' : ''}`} onClick={() => this.setState({ modoReporte: false, uncollapseRows: false, busqueda: '' }, this.loadDomiciliosList)}>
                                📋 Modo Lista
                            </button>
                            <button className={`btn-mode${modoReporte ? ' active' : ''}`} onClick={() => this.setState({ modoReporte: true }, this.goBusqueda)}>
                                📊 Modo Reporte
                            </button>
                            {modoReporte && (
                                <button className="btn-edit" style={{ padding: '8px 14px', fontSize: '0.82rem' }} onClick={() => this.descargarExcel(filtered, allClientes)}>
                                    📥 Excel
                                </button>
                            )}
                            {AuthenticationService.haveAuthorization("WRITE_DOMICILIOS") && (
                                <button style={styles.btnAdd} onClick={this.props.addElementClicked}>+ Domicilio</button>
                            )}
                        </div>
                    </div>

                    {/* Buscador */}
                    <div style={styles.searchCard}>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                            <div style={{ flex: 1, position: 'relative' }}>
                                <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: '0.85rem' }}>🔍</span>
                                <input
                                    className="dom-input"
                                    style={{ paddingLeft: 36 }}
                                    type="text"
                                    placeholder="Buscar domicilio... (mín. 3 caracteres + Enter)"
                                    value={busqueda}
                                    onChange={e => this.setState({ busqueda: e.target.value.toUpperCase(), elements: [] })}
                                    onKeyDown={e => { if (e.key === 'Enter') this.setState({ mostrarInactivas: true }, this.goBusqueda) }}
                                />
                            </div>
                            <button style={styles.btnSearch} onClick={() => this.setState({ mostrarInactivas: true }, this.goBusqueda)}>
                                Buscar
                            </button>
                        </div>
                    </div>

                    {/* Filtros modo reporte */}
                    {modoReporte && (
                        <div style={styles.filtersCard}>
                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#64748b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 12 }}>Período</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
                                <div>
                                    <label style={styles.filterLabel}>Proyecto</label>
                                    <select className="dom-select" onChange={e => {
                                        const found = allClientes.find(c => String(c.id) === e.target.value)
                                        this.setState({ cliente: found || '' })
                                    }}>
                                        <option value="">Todos</option>
                                        {allClientes.map(c => <option key={c.id} value={c.id}>{c.nombreCliente}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={styles.filterLabel}>Ejercicio</label>
                                    <select className="dom-select" value={String(ejercicio)}
                                        onChange={e => this.getGastosByPeriodoEjercicio(e.target.value, periodo)}>
                                        {EJERCICIOS.map(y => <option key={y} value={y}>{y}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={styles.filterLabel}>Período</label>
                                    <select className="dom-select" value={periodo} onChange={e => this.getGastosByPeriodoEjercicio(ejercicio, e.target.value)}>
                                        {MESES.map(m => <option key={m}>{m}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={styles.filterLabel}>Sociedad</label>
                                    <select className="dom-select" onChange={e => {
                                        const found = allSociedades.find(s => String(s.id) === e.target.value)
                                        this.setState({ sociedadSeleccionada: found || '' })
                                    }}>
                                        <option value="">Todas</option>
                                        {allSociedades.map(s => <option key={s.id} value={s.id}>{s.razonSocial}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Filtros generales */}
                    <div style={styles.filtersCard}>
                        <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#64748b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 12 }}>Filtros</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12, marginBottom: 14 }}>
                            <div>
                                <label style={styles.filterLabel}>Estado</label>
                                <select className="dom-select" value={estado} onChange={e => this.setFilterState({ estado: e.target.value, currentPage: 1 })}>
                                    <option value="">Todos</option>
                                    {estados.map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={styles.filterLabel}>Municipio</label>
                                <select className="dom-select" value={municipio} onChange={e => this.setFilterState({ municipio: e.target.value, colonia: '', calle: '', currentPage: 1 })}>
                                    <option value="">Todos</option>
                                    {municipios.map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={styles.filterLabel}>Colonia</label>
                                <select className="dom-select" value={colonia} onChange={e => this.setFilterState({ colonia: e.target.value, calle: '', currentPage: 1 })}>
                                    <option value="">Todas</option>
                                    {colonias.map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={styles.filterLabel}>Calle</label>
                                <select className="dom-select" value={calle} onChange={e => this.setFilterState({ calle: e.target.value, currentPage: 1 })}>
                                    <option value="">Todas</option>
                                    {calles.map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={styles.filterLabel}>Estatus</label>
                                <select className="dom-select" value={status} onChange={e => {
                                    const v = e.target.value
                                    this.setFilterState({ status: v, mostrarInactivas: v === 'INACTIVO', currentPage: 1 })
                                }}>
                                    <option value="">Todos</option>
                                    {['ACTIVO','INACTIVO','SIN ESTATUS'].map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={styles.filterLabel}>Control</label>
                                <select className="dom-select" value={control} onChange={e => this.setFilterState({ control: e.target.value, currentPage: 1 })}>
                                    <option value="">Todos</option>
                                    {['CONTROL','NO CONTROL'].map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={styles.filterLabel}>Tipo</label>
                                <select className="dom-select" value={tipo} onChange={e => this.setFilterState({ tipo: e.target.value, currentPage: 1 })}>
                                    <option value="">Todos</option>
                                    {['DEL CLIENTE','FISICO','VIRTUAL'].map(o => <option key={o}>{o}</option>)}
                                </select>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', paddingTop: 12, borderTop: '1px solid #f1f5f9' }}>
                            <label className="toggle-wrap" onClick={() => this.setFilterState({ mostrarInactivas: !mostrarInactivas })}>
                                <button className={`toggle ${mostrarInactivas ? 'on' : 'off'}`} type="button" />
                                <span style={{ fontSize: '0.82rem', color: '#475569' }}>Mostrar inactivos</span>
                            </label>
                            {uncollapseRows && (
                                <label className="toggle-wrap" onClick={() => this.setFilterState({ mostrarSociedadesFinalizadas: !mostrarSociedadesFinalizadas })}>
                                    <button className={`toggle ${mostrarSociedadesFinalizadas ? 'on' : 'off'}`} type="button" />
                                    <span style={{ fontSize: '0.82rem', color: '#475569' }}>Mostrar sociedades finalizadas</span>
                                </label>
                            )}
                        </div>
                        {(estado || municipio || colonia || calle || status || control || tipo) && (
                            <div style={{ paddingTop: 12, borderTop: '1px solid #f1f5f9', marginTop: 12 }}>
                                <button className="btn-edit" style={{ fontSize: '0.78rem' }}
                                    onClick={() => { clearDomFilters(); this.setFilterState({ estado: '', municipio: '', colonia: '', calle: '', status: '', control: '', tipo: '', mostrarInactivas: false, currentPage: 1 }) }}>
                                    ✕ Limpiar filtros
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Totales modo reporte */}
                    {modoReporte && filtered.length > 0 && (
                        <div style={styles.totalesCard}>
                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#64748b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 12 }}>Resumen</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 }}>
                                {[
                                    { label: 'Domicilios', value: counter },
                                    { label: 'Dom. Control', value: totalDomiciliosControl },
                                    { label: 'Sociedades', value: totalSociedades },
                                    { label: 'Socs. en Control', value: sociedadesDomiciliosControl },
                                    { label: 'Rentas Fijo', value: formatMoney(totalRentas) },
                                    { label: 'Rentas Capturadas', value: formatMoney(totalRentasRecibo) },
                                    { label: 'Gasto Período', value: formatMoney(totalPeriodo) },
                                    { label: 'Costo Unit. Prom.', value: formatMoney(totalPeriodo / totalDomiciliosControl / 5) },
                                    { label: 'Acumulado Anual', value: formatMoney(totalAnual) },
                                ].map(t => (
                                    <div key={t.label} style={styles.totalItem}>
                                        <span style={styles.totalLabel}>{t.label}</span>
                                        <span style={styles.totalValue}>{t.value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Error banner */}
                    {errorMsg && (
                        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '12px 16px', marginBottom: 12, color: '#dc2626', fontSize: '0.84rem', fontWeight: 500, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>⚠️ {errorMsg}</span>
                            <button onClick={() => this.setState({ errorMsg: '' })} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626', fontSize: '1rem', lineHeight: 1 }}>✕</button>
                        </div>
                    )}

                    {/* Spinner */}
                    {loading && <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><div className="spinner" /></div>}

                    {/* Tabla */}
                    {!loading && (
                        <div style={styles.tableCard} className="dom-table-wrap">
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className="dom-th" style={{ textAlign: 'center', width: 40 }}>#</th>
                                            <th className="dom-th sortable" onClick={() => this.sortBy('calle')}>Calle <SortIcon k="calle" /></th>
                                            <th className="dom-th">N. Ext-Int</th>
                                            <th className="dom-th sortable" onClick={() => this.sortBy('colonia')}>Colonia <SortIcon k="colonia" /></th>
                                            <th className="dom-th sortable" onClick={() => this.sortBy('municipio')}>Municipio <SortIcon k="municipio" /></th>
                                            <th className="dom-th sortable" onClick={() => this.sortBy('estado')}>Estado <SortIcon k="estado" /></th>
                                            <th className="dom-th" style={{ minWidth: 100 }}>Tel.</th>
                                            <th className="dom-th" style={{ textAlign: 'center', minWidth: 90 }}>Estatus</th>
                                            <th className="dom-th" style={{ textAlign: 'center', minWidth: 110 }}>Control</th>
                                            <th className="dom-th" style={{ textAlign: 'center', minWidth: 110 }}>Tipo</th>
                                            {uncollapseRows && <th className="dom-th sortable" onClick={() => this.sortBy('sociedadesCount')}>Sociedades <SortIcon k="sociedadesCount" /></th>}
                                            {uncollapseRows && <th className="dom-th" style={{ textAlign: 'right' }}>Renta Fijo</th>}
                                            {uncollapseRows && <th className="dom-th" style={{ textAlign: 'right' }}>Renta Cap.</th>}
                                            {uncollapseRows && <th className="dom-th" style={{ textAlign: 'right' }}>Costo Período</th>}
                                            {uncollapseRows && <th className="dom-th" style={{ textAlign: 'right' }}>Unit.</th>}
                                            {uncollapseRows && <th className="dom-th" style={{ textAlign: 'right' }}>Acum. Anual</th>}
                                            {AuthenticationService.haveAuthorization("WRITE_DOMICILIOS") && <th className="dom-th" style={{ textAlign: 'center', width: 40 }}></th>}
                                            {AuthenticationService.haveAuthorization("DELETE_DOMICILIOS") && <th className="dom-th" style={{ textAlign: 'center', width: 40 }}></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pageData.map((el, i) => {
                                            const n = (page - 1) * PAGE_SIZE + i + 1
                                            return (
                                                <tr key={el.id} className="dom-tr">
                                                    <td className="dom-td" style={{ textAlign: 'center', color: '#94a3b8', fontWeight: 600 }}>{n}</td>
                                                    <td className="dom-td"><Link to={`/domicilios/reportes/${el.id}`} className="dom-link">{el.calle}</Link></td>
                                                    <td className="dom-td" style={{ whiteSpace: 'nowrap' }}>
                                                        <Link to={`/domicilios/reportes/${el.id}`} className="dom-link">
                                                            {el.numeroExt}{el.numeroInterior ? ` - ${el.numeroInterior}` : ''}
                                                        </Link>
                                                    </td>
                                                    <td className="dom-td">{el.colonia}</td>
                                                    <td className="dom-td">{el.municipio}</td>
                                                    <td className="dom-td">{el.estado}</td>
                                                    <td className="dom-td" style={{ fontSize: '0.75rem', color: '#64748b', minWidth: 100, whiteSpace: 'nowrap' }}>{el.telefono || '—'}</td>
                                                    <td className="dom-td" style={{ textAlign: 'center', minWidth: 90 }}>{statusBadge(el.estatus)}</td>
                                                    <td className="dom-td" style={{ textAlign: 'center', minWidth: 110 }}>
                                                        {el.control ? <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20, background: el.control === 'CONTROL' ? '#eff6ff' : '#f1f5f9', color: el.control === 'CONTROL' ? '#2563eb' : '#64748b', border: `1px solid ${el.control === 'CONTROL' ? '#bfdbfe' : '#e2e8f0'}`, whiteSpace: 'nowrap', display: 'inline-block' }}>{el.control}</span> : <span style={{ color: '#cbd5e1' }}>—</span>}
                                                    </td>
                                                    <td className="dom-td" style={{ textAlign: 'center', minWidth: 110 }}>{tipoBadge(el.tipo)}</td>
                                                    {uncollapseRows && (
                                                        <td className="dom-td" style={{ maxWidth: 220 }}>
                                                            {el._socsNoFin?.map(s => (
                                                                <div key={s.id} style={{ marginBottom: 4, padding: '4px 0', borderBottom: '1px solid #f1f5f9' }}>
                                                                    <Link to={`/sociedades/reportes/${s.id}`} className="dom-link" style={{ fontSize: '0.75rem' }}>{s.razonSocial}</Link>
                                                                    <div style={{ fontSize: '0.68rem', color: '#94a3b8' }}>
                                                                        {s.fechaInicio && `Inicio: ${s.fechaInicio}`}
                                                                        {s.clientesIds?.map(cid => {
                                                                            const c = allClientes.find(x => x.id === cid)
                                                                            return c ? <span key={cid} style={{ marginLeft: 6, background: '#eff6ff', color: '#2563eb', borderRadius: 10, padding: '1px 6px', fontSize: '0.65rem' }}>{c.nombreCliente}</span> : null
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            {mostrarSociedadesFinalizadas && el._socsFinalizadas?.map(s => (
                                                                <div key={s.id} style={{ marginBottom: 4, padding: '4px 0', borderBottom: '1px solid #fef9c3', background: '#fffbeb', borderRadius: 6, paddingLeft: 4 }}>
                                                                    <Link to={`/sociedades/reportes/${s.id}`} className="dom-link" style={{ fontSize: '0.75rem', color: '#ca8a04' }}>{s.razonSocial}</Link>
                                                                    <div style={{ fontSize: '0.68rem', color: '#94a3b8' }}>Fin: {s.fechaFin}</div>
                                                                </div>
                                                            ))}
                                                        </td>
                                                    )}
                                                    {uncollapseRows && <td className="dom-td" style={{ textAlign: 'right', fontFamily: 'monospace', fontSize: '0.78rem' }}>{formatMoney(el.costoArrendamiento)}</td>}
                                                    {uncollapseRows && <td className="dom-td" style={{ textAlign: 'right', fontFamily: 'monospace', fontSize: '0.78rem' }}>{formatMoney(el.costoArrendamientoRecibo)}</td>}
                                                    {uncollapseRows && <td className="dom-td" style={{ textAlign: 'right', fontFamily: 'monospace', fontSize: '0.78rem' }}>{formatMoney(el.costoPeriodo)}</td>}
                                                    {uncollapseRows && <td className="dom-td" style={{ textAlign: 'right', fontFamily: 'monospace', fontSize: '0.78rem' }}>{formatMoney(el.costoPeriodo ? el.costoPeriodo / 5 : null)}</td>}
                                                    {uncollapseRows && <td className="dom-td" style={{ textAlign: 'right', fontFamily: 'monospace', fontSize: '0.78rem' }}>{formatMoney(el.costoAcumuladoAnual)}</td>}
                                                    {AuthenticationService.haveAuthorization("WRITE_DOMICILIOS") && (
                                                        <td className="dom-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-edit" onClick={() => this.props.updateElementClicked(el.id)}>✏️</button>
                                                        </td>
                                                    )}
                                                    {AuthenticationService.haveAuthorization("DELETE_DOMICILIOS") && (
                                                        <td className="dom-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-del" onClick={() => this.props.deleteElementClicked(el.id)}>🗑</button>
                                                        </td>
                                                    )}
                                                </tr>
                                            )
                                        })}
                                        {filtered.length === 0 && (
                                            <tr><td colSpan={20} style={{ textAlign: 'center', padding: '48px 0', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                Sin resultados. Usa el buscador o ajusta los filtros.
                                            </td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            {totalPages > 1 && (
                                <div style={styles.pagination}>
                                    <span style={styles.pageInfo}>Mostrando {(page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE, filtered.length)} de {filtered.length}</span>
                                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: 1 })} disabled={page===1}>«</button>
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: page-1 })} disabled={page===1}>‹</button>
                                        {getPageNumbers(page, totalPages).map((p, i) =>
                                            p === '...' ? <span key={i} style={{ padding: '0 4px', alignSelf: 'center', color: '#94a3b8' }}>…</span>
                                            : <button key={p} className={`page-btn${page===p?' active':''}`} onClick={() => this.setFilterState({ currentPage: p })}>{p}</button>
                                        )}
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: page+1 })} disabled={page===totalPages}>›</button>
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: totalPages })} disabled={page===totalPages}>»</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

function getPageNumbers(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
    if (current <= 4) return [1, 2, 3, 4, 5, '...', total]
    if (current >= total - 3) return [1, '...', total-4, total-3, total-2, total-1, total]
    return [1, '...', current-1, current, current+1, '...', total]
}

const styles = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 1400, margin: '0 auto' },
    pageHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    pageTitle: { margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    pageSubtitle: { margin: 0, fontSize: '0.82rem', color: '#94a3b8' },
    btnAdd: { padding: '9px 16px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(59,130,246,0.3)', fontFamily: "'Inter', sans-serif" },
    btnSearch: { padding: '9px 18px', background: '#0f172a', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif", whiteSpace: 'nowrap' },
    searchCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '16px 20px', marginBottom: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    filtersCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '16px 20px', marginBottom: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    filterLabel: { fontSize: '0.65rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.8px', textTransform: 'uppercase', display: 'block', marginBottom: 5 },
    totalesCard: { background: 'white', border: '1px solid #bfdbfe', borderRadius: 16, padding: '16px 20px', marginBottom: 12, boxShadow: '0 2px 8px rgba(59,130,246,0.08)' },
    totalItem: { background: '#f8fafc', borderRadius: 10, padding: '10px 14px', border: '1px solid #e2e8f0' },
    totalLabel: { display: 'block', fontSize: '0.68rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 },
    totalValue: { display: 'block', fontSize: '1rem', fontWeight: 700, color: '#0f172a' },
    tableCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 10 },
    pageInfo: { fontSize: '0.78rem', color: '#94a3b8' },
}

export default DomicilioComponent
